import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import AdminLayout from "./AdminLayout";
import ClubOverviewPage from "../../pages/admin/ClubOverviewPage";
import DonationsOverviewPage from "../../pages/admin/DonationsOverviewPage";
import SponsorsOverview from "../../pages/admin/SponsorsOverview";
import SportsmenOverview from "../../pages/admin/SportsmenOverview";
import EmailTemplatesOverviewPage from "../../pages/admin/EmailTemplatesOverviewPage";
import EmailTemplateEditPage from "../../pages/admin/EmailTemplateEditPage";
import ClubEditPage from "../../pages/admin/ClubEditPage";
import ManageManualTokensPage from "../../pages/admin/ManageManualTokensPage";

const AdminRoutes = () => {
  const { isAuthenticated, user, isAuthLoading } = useContext(AuthContext);

  if (isAuthLoading) {
    return null;
  }

  if (!isAuthenticated || user?.role !== "admin") {
    return <Navigate to="/" />;
  }

  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="dashboard" element={<div>Welcome to Admin Dashboard</div>} />
        <Route path="clubs" element={<ClubOverviewPage />} />
        <Route path="clubs/new" element={<ClubEditPage />} /> 
        <Route path="donations" element={<DonationsOverviewPage />} />
        <Route path="sponsors" element={<SponsorsOverview />} />
        <Route path="sportsmen" element={<SportsmenOverview />} />
        <Route path="email-templates" element={<EmailTemplatesOverviewPage />} />
        <Route path="email-templates/edit/:id" element={<EmailTemplateEditPage />} />
        <Route path="clubs/edit/:id" element={<ClubEditPage />} />        
        <Route path="manage-manual-tokens" element={<ManageManualTokensPage />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
